import React from 'react'
import {
    Create,
    TextInput,
    BooleanInput,
    SimpleForm,
    NumberInput,
    DateInput
}
    from 'react-admin'

import ExchangeRateTitle from './ExchangeRateTitle';

export default function ExchangeRateCreate(props) {
    return (
        <Create title={<ExchangeRateTitle />} {...props}>
            <SimpleForm>
                <DateInput source="currencyDate" />
                <TextInput source="currencyCode" />
                <NumberInput source="currencyRate" />
                <TextInput source="sourceId" />
                <BooleanInput source="active" />
            </SimpleForm>
        </Create>
    )
}
